import { useState, useEffect } from "react";
import { deleteAudio } from "../handlers/recordings-list";
import generateKey from "../shared/generate-key";

export default function useRecordingsList(audio) {
  const [recordings, setRecordings] = useState(null);

  useEffect(() => {
    if (audio)
      setRecordings((prevState) => {
        return { key: generateKey(), audio };
        return [...prevState, { key: generateKey(), audio }];
      });
  }, [audio]);

  return {
    recordings,
    deleteAudio: (audioKey) => deleteAudio(audioKey, setRecordings),
  };
}
